import { useAccount } from '@/store/account';
// 判断是否在 Electron 环境中
export const isElectron = (): boolean => {
	return '$gnb' in window;
};

// 一键登录
export const etaxClientLogin = async (cookie: any, action: any, bsqy: any) => {
	try {
		// 这里调用 Electron 相关的方法
		(window as any).$gnb.$desktop({ type: 'etaxLogin', data: { cookie: cookie, action: action, bsqy: bsqy } });
		// 处理返回结果
	} catch (error) {
		console.error('Electron userinfo error:', error);
		// 错误处理逻辑
	}
};

// 打开唯一标签
export const electronOpenUniqueTab = async (url: string, tabName: string) => {
	try {
		// 这里调用 Electron 相关的方法
		(window as any).$gnb.$desktop({ type: 'openUniqueTab', data: { url: url, tabName: tabName } });
		// 处理返回结果
	} catch (error) {
		console.error('Electron userinfo error:', error);
		// 错误处理逻辑
	}
};

// 打开自定义协议
export const openCustomProtocol = (uri: string) => {
	let appOpened = false;
	const storeAccount = useAccount();

	// 1. 尝试打开应用
	const iframe = document.createElement('iframe');
	iframe.style.display = 'none';
	iframe.src = uri;
	document.body.appendChild(iframe);

	// 2. 设置定时器监测
	const timer = setTimeout(() => {
		if (!appOpened) {
			storeAccount.openClientDialog();
			// window.location.href = 'https://download.lqzhcs.com.cn/electron-update/乐企SaaS Setup latest.exe'; // 替换为应用的下载链接
		}
	}, 3000); // 检测时间 (可调整)

	// 3. 监听页面可见性变化，判断是否成功唤起应用
	const onVisibilityChange = () => {
		appOpened = true;
		clearTimeout(timer);
	};

	document.addEventListener('visibilitychange', onVisibilityChange);
	window.addEventListener('blur', onVisibilityChange);

	// 清理 iframe
	setTimeout(() => {
		document.body.removeChild(iframe);
		window.removeEventListener('blur', onVisibilityChange);
		document.removeEventListener('visibilitychange', onVisibilityChange);
	}, 4000);
};
// 保存密码
export const savePassword = async (username: string, password: string, loginType: string) => {
	try {
		// 这里调用 Electron 相关的方法
		(window as any).$gnb.$desktop({
			type: 'savePassword',
			data: { username: username, password: password, loginType: loginType },
		});
		// 处理返回结果
	} catch (error) {
		console.error('Electron userinfo error:', error);
		// 错误处理逻辑
	}
};

// 获取密码
export const getPassword = async () => {
	try {
		// 使用 await 等待 Promise 解析
		const result = await (window as any).$gnb.$desktop({ type: 'getPassword' });
		return result;
		// 处理返回结果
	} catch (error) {
		console.error('Electron userinfo error:', error);
		// 错误处理逻辑
	}
};

// 数据存储
export const setStore = async (key: string, value: string) => {
	try {
		// 这里调用 Electron 相关的方法
		(window as any).$gnb.$desktop({ type: 'setStore', data: { key: key, value: value } });
		// 处理返回结果
	} catch (error) {
		console.error('Electron userinfo error:', error);
		// 错误处理逻辑
	}
};

// 数据获取
export const getStore = async (key: string) => {
	try {
		// 这里调用 Electron 相关的方法
		const result = await (window as any).$gnb.$desktop({ type: 'getStore', data: { key: key } });
		return result;
		// 处理返回结果
	} catch (error) {
		console.error('Electron userinfo error:', error);
		// 错误处理逻辑
	}
};

/**
 * 弹出窗口让用户选择, 并返回地址
 * @returns string
 */
export const getLocalFilePath = async () => {
	try {
		const result = await (window as any).$gnb.$desktop({ type: 'getDirPath' });
		return result.path;
	} catch (error) {
		console.error('Electron userinfo error:', error);
	}
};

/**
 * 打开目录指定的文件, 注意双斜杠
 */
export const openFile = async (filePath: string) => {
	try {
		const result = await (window as any).$gnb.$desktop({ type: 'openPath', data: { path: filePath } });
		return result;
	} catch (error) {
		console.error('Electron userinfo error:', error);
	}
};

/**
 * 在目录里展示文件, 注意双斜杠
 */
export const showFileInFolder = async (filePath: string) => {
	try {
		const result = await (window as any).$gnb.$desktop({ type: 'showInFolder', data: { path: filePath } });
		return result;
	} catch (error) {
		console.error('Electron userinfo error:', error);
	}
};

export interface DownloadItemParam {
	userName: string;
	fileName: string;
	fileUrl: string;
	filePath: string;
	kprq: string;
	sdfphm: string;
	fphm: string;
	fpdm: string;
	gmfmc:string;
	djkz2: string;
	djkz1: string;
	fplx: string;
}

export interface DownloadItemQuery {
	userName: string;
	sdfphm: string;
	fphm: string;
	fpdm: string;
	fplx: string;
	status: string;
	djkz2: string;
	djkz1: string;
	kprq: string;
	kprqStart: string;
	kprqEnd: string;
	page: number;
	pageSize: number;
}

export interface DownloadItem {
	userName: string;
	fileName: string;
	fileUrl: string;
	filePath: string;
	sdfphm: string;
	fphm: string;
	fpdm: string;
	fplx: string;
	djkz2: string;
	djkz1: string;
	pdfStatus?: string;
	ofdStatus?: string;
	xmlStatus?: string;
	printNum?: number;
	kprq?: string;
	createdAt?: string;
	updatedAt?: string;
}

/**
 *  下载文件
 */
export const dowloadFile = async (downloadList: DownloadItemParam[]) => {
	try {
		const result = await (window as any).$gnb.$desktop({ type: 'downloadFile', data: { downloadList: downloadList } });
		return result;
	} catch (error) {
		console.error('Electron userinfo error:', error);
	}
};

/**
 *  重新下载 只需传入 id 即可重新提交
 */
export const reDownloadTask = async (downloadList: number[]) => {
	try {
		const result = await (window as any).$gnb.$desktop({
			type: 'redownload',
			data: { redownloadIdList: downloadList },
		});
		return result;
	} catch (error) {
		console.error('Electron userinfo error:', error);
	}
};

/**
 *  查询下载记录
 */
export const queryDownloadTask = async (query: DownloadItemQuery) => {
	try {
		const result = await (window as any).$gnb.$desktop({ type: 'getDownloadTask', data: { queryParam: query } });
		return result;
	} catch (error) {
		console.error('Electron userinfo error:', error);
	}
};

/**
 *  更改文件状态:当文件打开失败时修改数据库状态为fail让用户可以重新下载
 */
export const changeDownloadStatus = async (id: number, type: string) => {
	try {
		const result = await (window as any).$gnb.$desktop({
			type: 'changeDownloadTaskStatus',
			data: { id: id, type: type, status: 'failed' },
		});
		return result;
	} catch (error) {
		console.error('Electron userinfo error:', error);
	}
};

// 获取打印机列表
export const getPrinterList = async () => {
	try {
		const result = await (window as any).$gnb.$desktop({ type: 'getPrinterInfo' });
		return result;
	} catch (error) {
		console.error('Electron userinfo error:', error);
	}
};
interface PrintOptions {
	margins?: {
		top?: number;
		bottom?: number;
		left?: number;
		right?: number;
	};
	landscape?: boolean;
	pageSize?: string | { width: number; height: number };
	copies?: number;
	rows?: number;
	rowNum?: number;
}
interface fileInfo {
	id: number;
	filePath: string;
}
// 打印文件
export const printPdf = async (options: PrintOptions, files: fileInfo[]) => {
	try {
		const result = await (window as any).$gnb.$desktop({
			type: 'printPdf',
			data: { options, files },
		});
		return result;
	} catch (error) {
		console.error('Electron userinfo error:', error);
	}
};
// 创建文件夹
export const createFolder = async (filepath: string) => {
	try {
		const result = await (window as any).$gnb.$desktop({
			type: 'createFolder',
			data: { filepath: filepath },
		});
		return result;
	} catch (error) {
		console.error('Electron userinfo error:', error);
	}
};

// 隐藏/显示客户端操作栏
export const electronHideIcon = async () => {
	(window as any).$gnb.$desktop({ type: 'hideIcon' });
};

// 根据URL关闭标签页
export const electronCloseTab = async (url: string) => {
	(window as any).$gnb.$desktop({ type: 'closeTabByURL', data: { url: url } });
};
